import "./PhenolicEngravingStock.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import MaterialDefinition from "./sections/MaterialDefinition";
import PhenolicProperties from "./sections/PhenolicProperties";
import StockColors from "./sections/StockColors";
import MilSpecStandards from "./sections/MilSpecStandards";
import WhereUsed from "./sections/WhereUsed";
import FaqAccordion from "./sections/FaqAccordion";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function PhenolicEngravingStockPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <MaterialDefinition />
      <PhenolicProperties />
      <StockColors />
      <MilSpecStandards />
      <WhereUsed />
      <FaqAccordion />
      <ClosingCta />
      <Footer />
    </div>;
}